import React from 'react';
import { TaxLatesDataOrders } from '../admin/TaxLatesDataOrders';

interface TaxLatesDataAdminViewProps {
  initialParams?: {
    taxOrderId?: string;
    tab?: string;
  } | null;
}

export function TaxLatesDataAdminView({ initialParams }: TaxLatesDataAdminViewProps = {}) {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-orange-500 to-blue-500 rounded-2xl shadow-lg p-6">
        <div className="flex items-center space-x-4">
          <img
            src="https://taxlatesdata.com/images/taxlates-logo-00.png"
            alt="TaxLatesData"
            className="h-12 w-auto bg-white px-3 py-1 rounded-lg"
          />
          <div>
            <h1 className="text-3xl font-bold text-white">TaxLatesData Admin</h1>
            <p className="text-white/90 mt-1">Manage orders, support, and customer communications</p>
          </div>
        </div>
      </div>

      {/* Orders Management */}
      <TaxLatesDataOrders initialOrderId={initialParams?.taxOrderId} />
    </div>
  );
}
